import { Button, CircularProgress, DialogContent, DialogTitle, FormControl, Grid, Icon, InputLabel, MenuItem, Select, Table, TableCell, TableRow, Tooltip, Typography } from "@mui/material"
import CustomDialog from "components/custom/CustomDialog"
import HeaderOuBannerDependendoDaInterpretacaoH1 from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1"
import { FlowBaixaContaReceberDTO, FlowContaBaixaDTO, TBaixarContaReceberProps, TContasBaixar } from "./financas.model"
import { useCallback, useEffect, useRef, useState } from "react"
import PagamentoService from "pages/pagamento/pagamento.service"
import { IAbstractModel } from "model/abstract.model"
import useCatchApiError from "hooks/useCatchApiError"
import dayjs from "dayjs"
import { DatePicker } from "@mui/x-date-pickers"
import { CustomButton } from "components/roundedbutton/CustomButton"
import { useSnackbarCustom } from "hooks/useSnackCustom"
import RegistraVendaService from "pages/registra-venda/registra-venda.service"
import { DadosPagamento, DadosPagamentoCartaoBandeiraTO, DadosPagamentoCartaoModosPagamentoTO, IDadosCheque, TDadosCartao, TipoInformacaoAdicional } from "pages/pagamento/pagamento.model"
import FinancasService from "./financas.service"
import { isEmpty } from "utils/util"
import { SourceType } from "react-number-format/types/types"
import ItemBaixarContaReceber from "components/ItemBaixarContaReceber"
import CustomLoading from "pages/Venda/Header/CustomLoading"
import { GenericTO } from "model/generic.model"
import InfiniteScrollVirtuoso from "components/infinitescrollvirtuoso/InfiniteScrollVirtuoso"
import FinancasIcon from "components/Icons/FinancasIcon"
import ChequeDialogContent from "pages/pagamento/formapagamento/dialogscontent/ChequeDialogContent"
import { FormaPagamentoDialog } from "pages/pagamento/formapagamento/FormaPagamentoDialog"
import { theme } from "theme";

const initialState = {
    flowBaixaContaReceberDTO: {
        dataLancamento: new Date().toISOString(),
        flowBaixaContaReceberDadosDTO: {
            formaPagamentoUUID: null,
            contaFinanceiraUUID: null,
            credenciadora: null,
            bandeira: null,
            modoPagamento: null,
            nsu: null,
            numControle: null
        },
        flowContaBaixasDTO: [],
        infoAdicionalTO: {
            descritivo: "",
            numeroParcelas: 1,
            tipo: TipoInformacaoAdicional.CHEQUE,
            dadosCheque: []
        }
    } as FlowBaixaContaReceberDTO,
    formasPagamentoOptions: [] as Array<IAbstractModel>,
    dadosCartao: {
        credenciadoras: [],
        bandeiras: [],
        modosPagamento: [],
    } as TDadosCartao,
    loading: true,
    isBaixando: false,
    chequeDialog: {
        open: false as boolean
    },
    isNew: true
}

const FORMAS_PAGAMENTO_REQUIRE_CONTA_FINANCEIRA = ["BOLETO BANCÁRIO", "CARTEIRA DIGITAL", "CASHBACK", "CREDIÁRIO", "CRÉDITO DE LOJA",
    "CRÉDITO VIRTUAL", "DÉBITO AUTOMÁTICO", "PAGAMENTO ELET. NÃO INFORMADO", "PROGRAMA DE FIDELIDADE", "TRANSFERÊNCIA BANCÁRIA",
    "PIX - ESTÁTICO", "DINHEIRO", "DEPÓSITO BANCÁRIO", "NOTA DE CRÉDITO", "PROGRAMA DE FIDELIDADE", "VALE PRESENTE", "OUTROS"
]


const BaixarContaReceber = (props: TBaixarContaReceberProps) => {
    const [stateLocal, setStateLocal] = useState(initialState)
    const pagamentoService = PagamentoService()
    const registraVendaService = RegistraVendaService();
    const financasService = FinancasService();
    const { throwErrorMessage } = useCatchApiError()
    const { addError } = useSnackbarCustom()
    const isFirstRender = useRef<boolean>(true)
    const [dadosPagamento, setDadosPagamento] = useState<DadosPagamento>({ valorRecebido: 0 });

    useEffect(() => {
        if (isFirstRender.current) {
            setInfos(props.contasFinanceiras[0])
        }
        isFirstRender.current = false
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (dadosPagamento.infoAdicional) {
            setStateLocal(prevState => ({
                ...prevState,
                flowBaixaContaReceberDTO: {
                    ...prevState.flowBaixaContaReceberDTO,
                    infoAdicionalTO: dadosPagamento.infoAdicional!
                },
                isNew: false
            }))
        }
    }, [dadosPagamento])

    const getFaltaReceber = useCallback((arr: Array<FlowContaBaixaDTO>) => {
        return arr.reduce((acc, item) => {
            return acc + (item.valorRecebido + item.multa + item.juros) - item.desconto
        }, 0)
    }, [])

    const getValorRecebido = useCallback((arr: Array<IDadosCheque>) => {
        return arr.reduce((acc, item) => {
            return acc + item.valor;
        }, 0);
    }, [])


    const hasError = useCallback((dadosCheque: Array<IDadosCheque>, dadosPagamento: Array<FlowContaBaixaDTO>) => {
        return getValorRecebido(dadosCheque) > getFaltaReceber(dadosPagamento)
        //eslint-disable-next-line
    }, [])

    const setInfos = async (contaFinanceiraPadrao: GenericTO) => {
        const formasPagamento = await getFormasPagagamento()
        const contasBaixaDTO = await getContasBaixar()

        setStateLocal(prevState => ({
            ...prevState,
            flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                flowContaBaixasDTO: contasBaixaDTO,

                flowBaixaContaReceberDadosDTO: {
                    ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                    formaPagamentoUUID: contasBaixaDTO.every(e => e.formaPagamentoUUID === contasBaixaDTO[0].formaPagamentoUUID) ? contasBaixaDTO[0].formaPagamentoUUID : null,
                    contaFinanceiraUUID: contaFinanceiraPadrao.uuid ?? null
                },
                infoAdicionalTO: {
                    ...prevState.flowBaixaContaReceberDTO.infoAdicionalTO,
                    dadosCheque: prevState.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque!.map(cheque => {
                        const totalRecebido = getFaltaReceber(contasBaixaDTO);
                        return {
                            ...cheque,
                            valor: totalRecebido,
                        };
                    })
                }
            },
            formasPagamentoOptions: formasPagamento,
            loading: false
        }))
    }

    const resetDadosCredenciadora = useCallback(() => {
        return setStateLocal(prevState => ({
            ...prevState,
            flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                flowBaixaContaReceberDadosDTO: {
                    ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                    credenciadora: initialState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora,
                    bandeira: initialState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira,
                    modoPagamento: initialState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.modoPagamento,
                    nsu: initialState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.nsu,
                    numControle: initialState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.numControle
                }
            }
        }))
    }, [])

    useEffect(() => {
        if (isFormaComCredenciadora(stateLocal.formasPagamentoOptions, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID)) {
            getDadosPagamentoCartao()
            return;
        }
        if (stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID) {
            resetDadosCredenciadora()
        }
        //eslint-disable-next-line
    }, [stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID])


    const getFormasPagagamento = useCallback(async () => {
        try {
            const { data } = await pagamentoService.getFormasPagamento()
            return data
        } catch (err) {
            throwErrorMessage(err ?? [])
            return []
        }
        //eslint-disable-next-line
    }, [])

    const getDadosPagamentoCartao = useCallback(async () => {
        try {
            const { data } = await registraVendaService.getDadosPagamentoCartao()
            setStateLocal(prevState => ({ ...prevState, dadosCartao: data }))
        } catch (err) {
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, [])

    const getContasBaixar = useCallback(async () => {
        try {
            const { data } = await financasService.getContasBaixar(!props.uuid ? props.uuids.map(e => e.uuid) : [props.uuid])
            return data
        } catch (err) {
            throwErrorMessage(err ?? [])
            return [];
        }
        //eslint-disable-next-line
    }, [])

    const enableContasFinanceiraSelect = useCallback((): boolean => {
        const formaPagamento = stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID
        if (!formaPagamento) return false
        const found = stateLocal.formasPagamentoOptions.find(e => e.uuid === formaPagamento)
        if (!found) return false;
        return FORMAS_PAGAMENTO_REQUIRE_CONTA_FINANCEIRA.includes(found.descritivo)
    }, [stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID, stateLocal.formasPagamentoOptions])

    const onSelectFormaPagamento = useCallback((e: any) => {
        setStateLocal(prevState => ({
            ...prevState,
            flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                flowBaixaContaReceberDadosDTO: {
                    ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                    formaPagamentoUUID: e.target.value,
                    contaFinanceiraUUID: !enableContasFinanceiraSelect() ? props.contasFinanceiras[0].uuid : null
                },
            },
            chequeDialog: {
                ...prevState.chequeDialog,
                open: isCheque(prevState.formasPagamentoOptions, e.target.value)
            }
        }))
        //eslint-disable-next-line
    }, [enableContasFinanceiraSelect])

    const onChangeDate = useCallback((e: any) => {
        if (!e) return setStateLocal(prevState => ({
            ...prevState, flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                dataLancamento: null
            }
        }))
        if (e.$D > 0 && e.$y > 0 && e.$d > 0) {
            setStateLocal(prevState => ({
                ...prevState,
                dataLancamento: e.$d

            }))
        }
    }, [])

    const isFormaComCredenciadora = useCallback((arr: Array<IAbstractModel>, uuid: string | null) => {
        const found = arr.find(e => e.uuid === uuid);
        if (!found) return false;
        return ["CARTÃO DE CRÉDITO", "CARTÃO DE DÉBITO", "PIX - DINÂMICO"].includes(found.descritivo);
    }, [])


    const onSelectCredenciadora = (e: any) => {
        setStateLocal(prevState => ({
            ...prevState,
            flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                flowBaixaContaReceberDadosDTO: {
                    ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                    credenciadora: e.target.value,
                    bandeira: null,
                    modoPagamento: null,
                }
            }
        }))
    }

    const onSelectBandeira = (e: any) => {
        setStateLocal(prevState => ({
            ...prevState,
            flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                flowBaixaContaReceberDadosDTO: {
                    ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                    bandeira: e.target.value,
                    modoPagamento: null,
                }
            }
        }))
    }

    const onSelectModoPagamento = (e: any) => {
        setStateLocal(prevState => ({
            ...prevState,
            flowBaixaContaReceberDTO: {
                ...prevState.flowBaixaContaReceberDTO,
                flowBaixaContaReceberDadosDTO: {
                    ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                    modoPagamento: e.target.value,
                }
            }
        }))
    }

    const getRenderValueCredenciadora = useCallback((credenciadoras: Array<IAbstractModel>, selectedItem: string) => {
        const selected = credenciadoras.find(tp => tp.uuid === selectedItem);
        return selected?.descritivo || '';
    }, [])

    const getRenderValueBandeira = useCallback((bandeiras: Array<DadosPagamentoCartaoBandeiraTO>, credenciadora: string | null, selectedItem: string) => {
        if (!credenciadora) return ""
        return bandeiras.find(e => e.credenciadoraUUID === credenciadora)?.bandeiras
            .find(e => e.uuidDadoCredenciadora === selectedItem)?.descritivo ?? ""
    }, [])

    const getRenderValueModoPagamento = useCallback((modosPagamento: DadosPagamentoCartaoModosPagamentoTO[],
        credenciadora: string | null, bandeira: string | null, selectedItem: string) => {
        return modosPagamento
            .find(e => e.credenciadoraUUID === credenciadora && e.bandeiraUUID === bandeira)?.modosPagamentos
            .find(e => e.uuidCredenciadoraTaxa === selectedItem)?.modoPagamento
    }, [])

    const renderBandeirasOptions = useCallback((bandeiras: Array<DadosPagamentoCartaoBandeiraTO>, credenciadora: string | null) => {
        if (!credenciadora) return;
        return (bandeiras.find(e => e.credenciadoraUUID === credenciadora)?.bandeiras.map(bandeira => {
            return (
                <MenuItem key={bandeira.uuidDadoCredenciadora} value={bandeira.uuidDadoCredenciadora}>
                    {bandeira.descritivo}
                </MenuItem>
            )
        }))
    }, [])

    const renderModosPagamentosOptions = (modosPagamento: Array<DadosPagamentoCartaoModosPagamentoTO>, flowBaixaContaReceberDTO: FlowBaixaContaReceberDTO) => {
        if (!flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora) return "";
        if (!flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira) return "";

        return modosPagamento.find(e => e.credenciadoraUUID === flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora
            && e.bandeiraUUID === flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira
        )?.modosPagamentos.map(mp => (
            <MenuItem key={mp.uuidCredenciadoraTaxa} value={mp.uuidCredenciadoraTaxa}>
                {mp.modoPagamento}
            </MenuItem>
        ))
    }

    const onValueChange = useCallback((floatValue: number | undefined, source: SourceType, item: FlowContaBaixaDTO, state: TContasBaixar) => {
        if (source === "event") {
            if (state === "valorRecebido" && floatValue === 0) {
                return setStateLocal(prevState => {
                    const updatedFlowContaBaixasDTO = [...prevState.flowBaixaContaReceberDTO.flowContaBaixasDTO];

                    const itemToUpdate = updatedFlowContaBaixasDTO.find(e => e.uuid === item.uuid);

                    if (itemToUpdate) {
                        itemToUpdate.multa = 0;
                        itemToUpdate.juros = 0;
                        itemToUpdate.desconto = 0;
                        itemToUpdate.valorRecebido = 0
                        itemToUpdate.totalRecebido = 0
                    }

                    return {
                        ...prevState,
                        flowBaixaContaReceberDTO: {
                            ...prevState.flowBaixaContaReceberDTO,
                            flowContaBaixasDTO: updatedFlowContaBaixasDTO
                        }
                    };
                });
            }

            if (state === "valorRecebido" && stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque && stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque.length === 1) {
                setStateLocal(prevState => {
                    const dadosChequeCopy = [...prevState.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque ?? []];

                    if (dadosChequeCopy.length > 0) {
                        dadosChequeCopy[0] = {
                            ...dadosChequeCopy[0],
                            valor: floatValue ?? 0
                        };
                    }

                    return {
                        ...prevState,
                        flowBaixaContaReceberDTO: {
                            ...prevState.flowBaixaContaReceberDTO,
                            infoAdicionalTO: {
                                ...prevState.flowBaixaContaReceberDTO.infoAdicionalTO,
                                dadosCheque: dadosChequeCopy
                            }
                        }
                    };
                });
            }

            setStateLocal(prevState => ({
                ...prevState,
                flowBaixaContaReceberDTO: {
                    ...prevState.flowBaixaContaReceberDTO,
                    flowContaBaixasDTO: prevState.flowBaixaContaReceberDTO.flowContaBaixasDTO.map((currentItem) => {
                        if (currentItem.uuid === item.uuid) {
                            return {
                                ...currentItem,
                                [state]: floatValue,
                            };
                        }
                        return currentItem;
                    })
                },
            }));
        }
        //eslint-disable-next-line
    }, [dadosPagamento.infoAdicional]);

    const onSelectContaFinanceira = useCallback((e: any) => {
        const found = props.contasFinanceiras.find(el => el.uuid === e.target.value)
        if (found) {
            setStateLocal(prevState => ({
                ...prevState,
                flowBaixaContaReceberDTO: {
                    ...prevState.flowBaixaContaReceberDTO,
                    flowBaixaContaReceberDadosDTO: {
                        ...prevState.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO,
                        contaFinanceiraUUID: found.uuid
                    }
                }
            }))
        }
        //eslint-disable-next-line
    }, [])


    const isDisabled = useCallback((item: FlowContaBaixaDTO) => {
        return item.multa > 0 || item.juros > 0 || item.desconto > 0
    }, [])

    const getValorTotalRecebido = useCallback((item: FlowContaBaixaDTO) => {
        return (item.valorRecebido ?? 0) + (item.multa ?? 0) + (item.juros ?? 0) - (item.desconto ?? 0)
    }, [])

    const baixarConta = useCallback(async (baixarDTO: FlowBaixaContaReceberDTO) => {
        try {
            const { data } = await financasService.baixarContasReceber(baixarDTO)
            return data
        } catch (err) {
            throwErrorMessage(err ?? [])
            return []
        }
        //eslint-disable-next-line
    }, [])

    const baixar = async (flowBaixaContaReceberDTO: FlowBaixaContaReceberDTO) => {
        setStateLocal(prevState => ({ ...prevState, isBaixando: true }))
        if (isCheque(stateLocal.formasPagamentoOptions, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID)) {
            if (isEmpty(stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque)) {
                setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
                return addError({ message: "É necessário informar os dados do cheque.", closeable: true, preventDuplicate: true, id: "dados-cheque-nao-informado", persist: false })
            }
            if (!isEmpty(stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque) && stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque?.some(e => e.vencimento === "")) {
                setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
                return addError({ message: "É necessário informar as datas de vencimento do cheques.", closeable: true, preventDuplicate: true, id: "dados-cheque-nao-informado_dois", persist: false })
            }
            if (getFaltaReceber(flowBaixaContaReceberDTO.flowContaBaixasDTO) > getValorRecebido(stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque ?? [])) {
                addError({ message: "Saldo do lançamento de cheque(s) diverge do total a receber.", id: "falta_receber_maior_recebido_cheque", closeable: true })
                return setStateLocal(prevState => ({ ...prevState, chequeDialog: { ...prevState.chequeDialog, open: true }, isBaixando: false }))
            }
            if (getValorRecebido(stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque ?? []) > getFaltaReceber(flowBaixaContaReceberDTO.flowContaBaixasDTO)) {
                addError({ message: "Saldo do lançamento de cheque(s) diverge do total a receber.", id: "valor_recebido_maior_falta_receber_cheque", closeable: true })
                return setStateLocal(prevState => ({ ...prevState, chequeDialog: { ...prevState.chequeDialog, open: true }, isBaixando: false }))
            }
        }

        if (!flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID) {
            setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
            return addError({ message: "É necessário informar uma forma de pagamento.", closeable: true, preventDuplicate: true, id: "forma-pagamento-nula-error", persist: false })
        }
        if (!flowBaixaContaReceberDTO.dataLancamento) {
            setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
            return addError({ message: "É necessário informar uma data de lançamento.", closeable: true, preventDuplicate: true, id: "data-lancamento-nula-error", persist: false })
        }
        if (isFormaComCredenciadora(stateLocal.formasPagamentoOptions, flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID)) {
            if (!stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora) {
                setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
                return addError({ message: "É necessário informar uma credenciadora.", closeable: true, preventDuplicate: true, id: "credenciadora-nula-error", persist: false })
            }
            if (!flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira) {
                setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
                return addError({ message: "É necessário informar uma bandeira.", closeable: true, preventDuplicate: true, id: "bandeira-nula-error", persist: false })
            }
            if (!flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.modoPagamento) {
                setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
                return addError({ message: "É necessário informar um modo de pagamento.", closeable: true, preventDuplicate: true, id: "modo-pagamento-nula-error", persist: false })
            }
        }
        flowBaixaContaReceberDTO.flowContaBaixasDTO.map(e =>
            e.totalRecebido = getValorTotalRecebido(e)
        )
        const baixados = await baixarConta(flowBaixaContaReceberDTO)
        setStateLocal(prevState => ({ ...prevState, isBaixando: false }))
        props.onCloseReturning(baixados)
    }

    const fixedHeaderContent = useCallback(() => {
        return (
            <TableCell sx={{
                width: '100%',
                borderBottom: `1px solid ${theme.palette.text.disabled}`,
                maxHeight: "55px",
                color: theme.palette.common.black,
                padding: 0
            }}>
                <TableRow sx={{
                    border: 0,
                    display: "flex"
                }}>
                    <TableCell sx={{
                        width: "32.5%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                        paddingLeft: "15px",
                    }}>
                        Descrição
                    </TableCell>

                    <TableCell sx={{
                        width: "5%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                        textAlign: "center",
                    }}>
                        Parcela
                    </TableCell>

                    <TableCell sx={{
                        width: "9%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                        textAlign: "center",
                    }}>
                        Vencimento
                    </TableCell>

                    <TableCell sx={{
                        width: "10%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                        textAlign: "center"
                    }}>
                        Valor aberto
                    </TableCell>

                    <TableCell sx={{
                        width: "10%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                    }} align="center">
                        Valor recebido
                    </TableCell>

                    <TableCell sx={{
                        width: "7.5%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0
                    }} align="center">
                        Multa
                    </TableCell>

                    <TableCell sx={{
                        width: "7.5%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                    }} align="center">
                        Juros
                    </TableCell>

                    <TableCell sx={{
                        width: "7.5%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0
                    }} align="center">
                        Desconto
                    </TableCell>

                    <TableCell sx={{
                        width: "10%",
                        fontWeight: "bold",
                        border: 0,
                        padding: 0,
                    }} align="center">
                        Total recebido
                    </TableCell>
                </TableRow >
            </TableCell >
        )
    }, [])

    const renderItem = useCallback((item: FlowContaBaixaDTO) => {
        return (
            <ItemBaixarContaReceber
                item={item}
                isDisabled={isDisabled}
                getValorTotalRecebido={getValorTotalRecebido}
                onValueChange={onValueChange}
            />
        )
        //eslint-disable-next-line
    }, [])

    const onClickCheque = useCallback(() => {
        setStateLocal(prevState => ({
            ...prevState,
            chequeDialog: {
                ...prevState.chequeDialog,
                open: true
            }
        }))
    }, [])

    const onConfirmCheque = useCallback(() => {
        if (!dadosPagamento.infoAdicional?.dadosCheque?.every(item =>
            item.vencimento && item.banco?.uuid && item.agencia && item.numeroCheque && item.emitente)) {
            return addError({ message: 'Preencha os dados do cheque.', closeable: true, id: "erro-preencha-dados-cheque-baixar-financas" });
        }
        if (getValorRecebido(dadosPagamento.infoAdicional?.dadosCheque) < getFaltaReceber(stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO)) {
            return addError({ message: 'Saldo do lançamento de cheque(s) diverge do total a receber.', closeable: true, id: "erro-preencha-valor-cheque-baixar-financas" });
        }

        setStateLocal(prevState => ({
            ...prevState,
            chequeDialog: {
                ...prevState.chequeDialog,
                open: false
            }
        }))
        //eslint-disable-next-line
    }, [dadosPagamento])

    const onCloseChequeDialog = useCallback(() => {
        if (stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque?.some(e => !e.banco || !e.agencia || !e.numeroCheque || !e.emitente || !e.vencimento)) {

        }

        setStateLocal(prevState => ({
            ...prevState, chequeDialog: {
                ...prevState.chequeDialog,
                open: false,
            },

        }))
        //eslint-disable-next-line
    }, [])



    const isCheque = useCallback((arr: Array<IAbstractModel>, formaPagamentoUUID: string | null) => {
        return arr.find(e => e.uuid === formaPagamentoUUID)?.descritivo === "CHEQUE"
    }, [])

    const endAdornment = useCallback((isFormaPagamentoCheque: boolean, dadosCheque: Array<IDadosCheque>, flowContaBaixasDTO: FlowContaBaixaDTO[]) => {
        if (isFormaPagamentoCheque) {
            return (
                <Tooltip title="Informe os dados do cheque">
                    <Button sx={{
                        padding: 0,
                        margin: 0,
                        border: 0,
                        marginTop: "10px",
                        width: "80px",
                        marginLeft: "15px"
                    }}
                        onClick={onClickCheque}>
                        <FinancasIcon fontSize="40px" color={getFaltaReceber(flowContaBaixasDTO) > getValorRecebido(dadosCheque) ||
                            getValorRecebido(dadosCheque) > getFaltaReceber(flowContaBaixasDTO) ||
                            isEmpty(dadosCheque) ? "red" : dadosCheque.every(e => e.vencimento) ? theme.palette.text.disabled : "red"} />
                    </Button>
                </Tooltip>
            )
        }
        return <></>
        //eslint-disable-next-line
    }, [])

    return (
        <>
            <CustomDialog
                open={!stateLocal.chequeDialog.open}
                fullWidth
                maxWidth={'xl'}
                sx={{
                    maxWidth: "90vw"
                }}
                onClose={props.onClose}
            >
                <DialogTitle id="dialog-title" textAlign={'center'}>
                    <HeaderOuBannerDependendoDaInterpretacaoH1
                        id='baixar-conta-receber'
                        iconClassName='fa-solid fa-sack-dollar'
                        label='Baixar conta receber'
                    />
                </DialogTitle>

                <DialogContent sx={{
                    overflowX: 'hidden'
                }}>
                    <Grid container>
                        <Grid item
                            xs={enableContasFinanceiraSelect() ? 6 : 9}
                            md={enableContasFinanceiraSelect() ? 6 : 9}
                            lg={enableContasFinanceiraSelect() ? 6 : 9}
                            marginBottom="20px"
                        >
                            <FormControl fullWidth variant="standard" error={false} sx={{ width: "90%" }}>
                                <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">
                                    Forma de pagamento *
                                </InputLabel>
                                <Select
                                    id="tipo-pessoa-component"
                                    inputProps={{ id: 'tipo-pessoa-input' }}
                                    value={stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID ?? ''}
                                    onChange={onSelectFormaPagamento}
                                    disabled={stateLocal.loading}
                                    renderValue={(selectedItem) => {
                                        const selected = stateLocal.formasPagamentoOptions.find(tp => tp.uuid === selectedItem);
                                        return selected?.descritivo || '';
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                                width: 100
                                            },
                                        },
                                    }}

                                >
                                    {stateLocal.formasPagamentoOptions.map(tp => (
                                        <MenuItem key={tp.uuid} value={tp.uuid}>
                                            {tp.descritivo}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                            {endAdornment(isCheque(stateLocal.formasPagamentoOptions,
                                stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID),
                                stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque ?? [],
                                stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO)}
                        </Grid>

                        {enableContasFinanceiraSelect() && (
                            <Grid item xs={3} md={3} lg={3}>
                                <FormControl fullWidth variant="standard" error={false} sx={{ width: "96%" }}>
                                    <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">
                                        Contas Financeira *
                                    </InputLabel>
                                    <Select
                                        id="tipo-pessoa-component"
                                        inputProps={{ id: 'tipo-pessoa-input' }}
                                        value={stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.contaFinanceiraUUID ?? ''}
                                        onChange={onSelectContaFinanceira}
                                        disabled={stateLocal.loading}
                                        renderValue={(selectedItem) => {
                                            const selected = props.contasFinanceiras.find(cf => cf.uuid === selectedItem);
                                            return selected?.descritivo || '';
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 48 * 4.5 + 8,
                                                    width: 100
                                                },
                                            },
                                        }}
                                    >
                                        {props.contasFinanceiras.map(cf => (
                                            <MenuItem key={cf.uuid} value={cf.uuid}>
                                                {cf.descritivo}
                                            </MenuItem>
                                        ))}
                                    </Select>

                                </FormControl>
                            </Grid>
                        )}

                        <Grid xs={3} md={3} lg={3}>
                            <FormControl sx={{
                                width: '100%',
                                height: '40px',
                                marginTop: "7px"
                            }}>
                                <DatePicker
                                    slotProps={{
                                        textField: {
                                            variant: 'standard',
                                            onChange: (e: any) => onChangeDate(e),
                                        }
                                    }}
                                    label="Data de lançamento *"
                                    maxDate={dayjs(new Date())}
                                    format='DD/MM/YYYY'
                                    value={dayjs(stateLocal.flowBaixaContaReceberDTO.dataLancamento)}
                                    onChange={(e: any) => setStateLocal(prevState => ({ ...prevState, flowBaixaContaReceberDTO: { ...prevState.flowBaixaContaReceberDTO, dataLancamento: e.$d } }))}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    {isFormaComCredenciadora(stateLocal.formasPagamentoOptions, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.formaPagamentoUUID) && (
                        <Grid container sx={{ marginBottom: "10px" }}>
                            <Grid item xs={6} md={6} lg={6}>
                                <FormControl fullWidth variant="standard" error={false} sx={{ width: "96%" }}>
                                    <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">
                                        Credenciadora *
                                    </InputLabel>
                                    <Select
                                        id="tipo-pessoa-component"
                                        inputProps={{ id: 'tipo-pessoa-input' }}
                                        value={stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora ?? ''}
                                        onChange={onSelectCredenciadora}
                                        renderValue={(selectedItem) => getRenderValueCredenciadora(stateLocal.dadosCartao.credenciadoras, selectedItem)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 48 * 4.5 + 8,
                                                    width: 100
                                                },
                                            },
                                        }}
                                    >
                                        {stateLocal.dadosCartao.credenciadoras.map(tp => (
                                            <MenuItem key={tp.uuid} value={tp.uuid}>
                                                {tp.descritivo}
                                            </MenuItem>
                                        ))}
                                    </Select>

                                </FormControl>
                            </Grid>

                            <Grid xs={3} md={3} lg={3}>
                                <FormControl fullWidth variant="standard" error={false} sx={{ width: "96%" }}>
                                    <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">
                                        Bandeira *
                                    </InputLabel>
                                    <Select
                                        id="tipo-pessoa-component"
                                        inputProps={{ id: 'tipo-pessoa-input' }}
                                        value={stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira ?? ""}
                                        onChange={onSelectBandeira}
                                        renderValue={(selectedItem) => getRenderValueBandeira(stateLocal.dadosCartao.bandeiras, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora, selectedItem)}
                                        disabled={!stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 48 * 4.5 + 8,
                                                    width: 100
                                                },
                                            },
                                        }}
                                    >
                                        {renderBandeirasOptions(stateLocal.dadosCartao.bandeiras, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora)}
                                    </Select>

                                </FormControl>
                            </Grid>

                            <Grid xs={3} md={3} lg={3}>
                                <FormControl fullWidth variant="standard" error={false} sx={{ width: "96%" }}>
                                    <InputLabel id="tipo-pessoa-label" htmlFor="tipo-pessoa-input">
                                        Modo de pagamento *
                                    </InputLabel>
                                    <Select
                                        id="tipo-pessoa-component"
                                        inputProps={{ id: 'tipo-pessoa-input' }}
                                        value={stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.modoPagamento ?? ""}
                                        onChange={onSelectModoPagamento}
                                        disabled={!stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira}
                                        renderValue={(selectedItem) => getRenderValueModoPagamento(stateLocal.dadosCartao.modosPagamento, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.credenciadora, stateLocal.flowBaixaContaReceberDTO.flowBaixaContaReceberDadosDTO.bandeira, selectedItem)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 48 * 4.5 + 8,
                                                    width: 100
                                                },
                                            },
                                        }}
                                    >
                                        {renderModosPagamentosOptions(stateLocal.dadosCartao.modosPagamento, stateLocal.flowBaixaContaReceberDTO)}
                                    </Select>

                                </FormControl>
                            </Grid>
                        </Grid>
                    )}


                    {isEmpty(stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO) && stateLocal.loading && (
                        <Table sx={{
                            border: `2px solid ${theme.palette.primary.main}`,
                            display: "flex",
                            height: "400px",
                            marginTop: "20px"
                        }}>

                            <CircularProgress
                                size={48}
                                color='primary'
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-12px',
                                    marginLeft: '-12px',
                                }}
                            />
                        </Table>

                    )}

                    {isEmpty(stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO) && !stateLocal.loading && (
                        <Typography sx={{
                            width: '100%',
                            textAlign: "center",
                            marginTop: "30px",
                            fontSize: "30px",
                            color: theme.palette.text.disabled,
                            alignSelf: "center",
                            userSelect: "none",
                        }}>
                            Nenhum histórico de movimentação encontrado.
                        </Typography>
                    )}

                    {!isEmpty(stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO) && (
                        <InfiniteScrollVirtuoso
                            fixedHeaderContent={fixedHeaderContent}
                            data={stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO}
                            fixedFooterContent={() => <></>}
                            heightScale="370px"
                            renderItem={({ data }) => renderItem(data)}
                            key='contas_baixar_infinite_scroll_virtuoso'
                        />
                    )}

                    <Grid item
                        sx={{
                            bottom: '15px',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                            marginTop: "15px"
                        }}
                    >
                        <CustomButton
                            sx={{ minWidth: '80px' }}
                            id="voltar-configuracao-vale-presente-btn"
                            onClick={props.onClose}
                            variant="contained"
                            color="error"
                            startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                            Voltar
                        </CustomButton>

                        <CustomButton
                            sx={{ minWidth: '80px' }}
                            id="voltar-configuracao-vale-presente-btn"
                            onClick={() => baixar(stateLocal.flowBaixaContaReceberDTO)}
                            variant="contained"
                            color="success"
                            startIcon={<Icon className='fa-solid fa-check' />}>
                            Baixar
                        </CustomButton>
                    </Grid>
                </DialogContent>
            </CustomDialog>
            {stateLocal.isBaixando &&
                <CustomLoading />
            }

            <FormaPagamentoDialog
                preventConfirmar={{
                    value: false,
                    setPreventConfirmar: () => { }
                }}
                disableDefaultButtons={false}
                disableTitle={false}
                open={stateLocal.chequeDialog.open}
                confirmButton={{
                    onConfirm: onConfirmCheque,
                    disabled: false
                }}
                setSubmitted={() => { }}
                onClose={onCloseChequeDialog}
                title="Cheque"
                fullWidth={true}
                maxWidth={"lg"}
            >
                <ChequeDialogContent error={{ hasError: hasError(stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque ?? [], stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO ?? []), setHasError: () => { } }} isNew={stateLocal.isNew}
                    valorRecebido={{
                        dadosPagamento: {
                            valorRecebido: getValorRecebido(stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO.dadosCheque ?? []),
                            infoAdicional: stateLocal.flowBaixaContaReceberDTO.infoAdicionalTO
                        },
                        setDadosPagamento
                    }}
                    customFaltaReceber={getFaltaReceber(stateLocal.flowBaixaContaReceberDTO.flowContaBaixasDTO)}
                />
            </FormaPagamentoDialog>

        </>
    )
}

export default BaixarContaReceber
